!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["react-twitch-embed-video"] = t() : e["react-twitch-embed-video"] = t();
}("undefined" != typeof self ? self : this, function () {
  return webpackJsonpreact_twitch_embed_video([1], [function (e, t, n) {
    "use strict";

    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    function r(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var s = n(1),
        a = n.n(s),
        c = n(4),
        d = n.n(c),
        p = n(7),
        u = n.n(p),
        l = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        f = function (e) {
      function t() {
        return o(this, t), i(this, (t.__proto__ || Object.getPrototypeOf(t)).apply(this, arguments));
      }

      return r(t, e), l(t, [{
        key: "componentDidMount",
        value: function value() {
          var e = this;
          if (u.a.Twitch && u.a.Twitch.Embed) this.embed = new u.a.Twitch.Embed(this.props.targetClass, Object.assign({}, this.props)), this._addEventListeners();else {
            var t = document.createElement("script");
            t.setAttribute("src", "https://embed.twitch.tv/embed/v1.js"), t.addEventListener("load", function () {
              e.embed = new u.a.Twitch.Embed(e.props.targetClass, Object.assign({}, e.props)), e._addEventListeners();
            }), document.body.appendChild(t);
          }
        }
      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function value(e) {
          var t = this.props.channel !== e.channel,
              n = this.props.layout !== e.layout;

          if (t || n) {
            document.getElementById(e.targetClass).innerHTML = "", this.embed = null, this.embed = new window.Twitch.Embed(this.props.targetClass, Object.assign({}, e));
          }
        }
      }, {
        key: "_addEventListeners",
        value: function value() {
          this.embed.addEventListener(u.a.Twitch.Embed.AUTHENTICATE, function (e) {
            this.props.onUserLogin && this.props.onUserLogin(e);
          }.bind(this)), this.embed.addEventListener(u.a.Twitch.Embed.VIDEO_PLAY, function (e) {
            this.props.onVideoPlay && this.props.onVideoPlay(e);
          }.bind(this)), this.embed.addEventListener(u.a.Twitch.Embed.VIDEO_READY, function () {
            var e = this.props,
                t = e.autoplay,
                n = e.muted,
                o = this.embed.getPlayer();
            n && o.setVolume(0), !1 === t && o.pause(), this.props.onPlayerReady && this.props.onPlayerReady(o);
          }.bind(this));
        }
      }, {
        key: "render",
        value: function value() {
          return a.a.createElement("div", {
            id: this.props.targetClass
          });
        }
      }]), t;
    }(s.PureComponent);

    f.propTypes = {
      targetClass: d.a.string,
      channel: d.a.string.isRequired,
      video: d.a.string.isRequired,
      width: d.a.oneOfType([d.a.string, d.a.number]),
      height: d.a.oneOfType([d.a.string, d.a.number]),
      allowfullscreen: d.a.bool,
      autoplay: d.a.bool,
      chat: d.a.oneOf(["default", "mobile"]),
      collection: d.a.string,
      layout: d.a.string,
      muted: d.a.bool,
      theme: d.a.string,
      onUserLogin: d.a.func,
      onVideoPlay: d.a.func,
      onPlayerReady: d.a.func
    }, f.defaultProps = {
      targetClass: "twitch-embed",
      width: "940",
      height: "480",
      autoplay: !0,
      muted: !1
    }, t.default = f;
  }], [0]);
});